import { useVendorList } from "Shared/queries/vendors/vendor.queries"

import { TablesEnum } from "../store/reducers/tableConfigReducer"
import { buildQueryParamsFromTableConfig, isVendorTableFilterApplied } from "../utils/table.utils"
import { useTableFilterObject } from "./table.hooks"
import { useTableConfig } from "./tableConfig.hooks"

export const useVendorTable = () => {
    const tableConfig = useTableConfig(TablesEnum.VENDORS)
    const queryParams = buildQueryParamsFromTableConfig(tableConfig)
    const filterObject = useTableFilterObject(TablesEnum.VENDORS)

    const isFilterApplied = !!isVendorTableFilterApplied(filterObject)

    const { data, isError, isFetching, refetch } = useVendorList(queryParams, filterObject)

    const shouldShowSearch = !!(data?.totalDocs! > 0 || queryParams.search)

    return { data, isError, isFetching, refetch, queryParams, isFilterApplied, shouldShowSearch }
}
